import { StoryDefault, StoryStatus, StorySettings } from 'data/enums';
//import { COLLECTION_NAME } from "services/stories";
//import { addDocument } from "db/mutations";
import normalize from 'utils/normalize';
import { auth } from 'db/config';

/**
 * Crea la historia para el usuario correspondiente.
 * @params {Object} settings - Configuración de la historia
 * @params {Object} storyData - Datos de la historia a crear
 * @params {Object} userCredits - Créditos del usuario
 * @returns {Promise<Object>} - Devuelve el estado de la historia creada
 */
export const createStory = async ({ settings, storyData, userCredits }) => {
  const user = auth.currentUser;
  const token = await user.getIdToken();

  const res = await fetch(process.env.MONUS_ENDPOINT + '/generateStory', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify({
      user_data: userCredits,
      user_inputs: Object.assign({}, StoryDefault, storyData),
      settings: Object.assign({}, StorySettings, settings),
      verbose: 1,
    }),
  });

  if (!res.ok) {
    const errorText = await res.text();
    console.log('Fetch error:', res.status, errorText);
  }

  const data = await res.json();
  const status = normalize(data.status);
  const success = StoryStatus.SUCCESS;

  if ((status !== success && status !== '200') || !data.doc_id) {
    return null;
  }

  return data.doc_id;
};
